import React from 'react';
import {
  Drawer,
  DrawerContent,
} from "./drawer"
import { cn } from '@/lib/utils';

export type VerticalDrawerProps = {
  className?: string;
  children: React.ReactNode;
  direction?: 'left' | 'right';
  handleOnly?: boolean;
  open?: boolean;
  onOpenChange?: (open: boolean) => void;
}

export const VerticalDrawer = ({children, direction = 'right', handleOnly = false, open, onOpenChange}: VerticalDrawerProps) => {
  return (
    <Drawer direction={direction} handleOnly={handleOnly} open={open} onOpenChange={onOpenChange}>
      {children}
    </Drawer>
  )
};

export const VerticalDrawerContent = ({ className, children }: VerticalDrawerProps) => {
  return (
    <DrawerContent className={cn(["mt-0 h-full w-full md:w-[30rem] right-0 ml-auto mr-0 rounded-none", className])}>
      {children}
    </DrawerContent>
  )
};
